module.exports = __webpack_public_path__ + "static/media/sp17.de177046.JPG";